import { defineExternalSignals } from "../core/composition/define-external-signals.js";
import { defineFeature } from "../core/composition/define-feature.js";
import { loadAudioSegments } from "../behaviors/dom/load-segments.js";
import { switchAudioTrack } from "../behaviors/track-switching.js";
import { canPlayTrack } from "../media/dom/capabilities.js";
import { setupAudioBufferActors } from "../behaviors/dom/setup-buffer-actors.js";
import { resolveAudioTrack } from "../behaviors/resolve-track.js";
import { reportUnsupportedTrackConditions } from "../playback/primitives/report-track-conditions.js";
//#region src/playback/features/audio.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [
	resolveAudioTrack,
	switchAudioTrack,
	setupAudioBufferActors,
	loadAudioSegments,
	defineExternalSignals()({ state: ["userAudioTrackSelection"] })
];
/** The config defaults the feature contributes. */
const defaultConfig = {
	canPlayTrack,
	reportUnsupportedTrackConditions
};
/** The state values the feature seeds. */
const initialState = {};
/**
* Plays audio: resolves the selected rendition's playlist, switches renditions, and buffers and loads its segments.
* Honors the user's `userAudioTrackSelection`, such as a language.
*
* Requires, from this or other features:
*
* - A writer of `context.mediaSource`, such as `mediaSourceFeature`; nothing loads without one.
* - A writer of `state.currentTime`, such as `currentTimeFeature`; without one, loading stops after the first window.
* - A writer of `state.loadActivated`, such as `initialLoadFeature`, or a seeded `loadActivated: true`; without one, only
*   init segments load.
*/
const audioFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { audioFeature, behaviors, defaultConfig, initialState };
